import { useDismissFlag } from './useDismissFlag';

const STORAGE_KEY = 'conditional-badge-seen';

/** "NEW" badge on the Conditional L1 tab, cleared on visit (FORECASTUI-2583). */
export function useConditionalsBadge() {
  const { isActive, markDone } = useDismissFlag(STORAGE_KEY);

  return {
    showBadge: isActive,
    markSeen: markDone,
  };
}
